var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quick-tagger"},[_c('tag-input',{attrs:{"src":_vm.$attrs['src'],"placeholder":_vm.labels['placeholder']},model:{value:(_vm.currentTags),callback:function ($$v) {_vm.currentTags=$$v},expression:"currentTags"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }